export default "__VITE_ASSET__DeoXGp8o__"